<template>
  <sidenav
    v-click-outside="expandOff"
    v-if="!printMode"
    :orientation="orientation"
    class="sidenav sidenav-vertical layout-sidenav bg-sidenav-theme"
  >
    <!-- Brand -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal">
        <span class="logo">
          <img src="/img/logo_white.svg" alt="Floor Plan Mapper" />
        </span>
      </router-link>
      <a href="#" class="layout-sidenav-toggle sidenav-link text-large ml-auto d-lg-none" @click.prevent="expandOff">
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
      <sidenav-router-link icon="lnr lnr-home" to="/" exact>Home</sidenav-router-link>
      <sidenav-router-link icon="lnr lnr-map" to="/map">Map</sidenav-router-link>
      <sidenav-router-link
        icon="lnr lnr-apartment"
        to="/floors"
        v-if="can(PN.FLOOR_CREATE) || can(PN.FLOOR_UPDATE) || can(PN.FLOOR_DELETE)"
        :exact="true"
      >
        Floors
      </sidenav-router-link>
      <sidenav-router-link icon="lnr lnr-users" to="/employees" v-if="can(PN.USER_CRUD)">Employees </sidenav-router-link>
      <sidenav-router-link icon="lnr lnr-user" to="/users" v-if="can(PN.USER_CRUD)">Users </sidenav-router-link>
      <sidenav-router-link
        icon="lnr lnr-map-marker"
        to="/point-icons"
        v-if="can(PN.POINT_UPDATE) || can(PN.POINT_CREATE) || can(PN.POINT_DELETE)"
        >Custom Icons
      </sidenav-router-link>
      <sidenav-router-link icon="lnr lnr-cog" to="/settings" v-if="can(PN.PERMISSION_CRUD)">Settings</sidenav-router-link>
    </div>
  </sidenav>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import { Sidenav, SidenavRouterLink } from '@/assets/libs/sidenav'

export default {
  name: 'AppSidenav',
  data: () => ({ PN }),
  components: {
    Sidenav,
    SidenavRouterLink
  },
  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },
  computed: {
    ...mapState('map', ['printMode']),
    ...mapGetters('rbac', ['can'])
  },
  methods: {
    ...mapActions(['setSidenavClass']),
    expandOff() {
      this.setSidenavClass('')
    },
    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0
    },
    isMenuOpen(url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    }
  }
}
</script>

<style scoped lang="scss">
.sidenav {
  transition: transform 0.5s;
}

.logo {
  & > img {
    padding: 10px 15px 10px 10px;
  }
}
</style>
